<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    :return-value.sync="lazyValue"
    offset-y nudge-top="26"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field full-width
                    color="#008EF0"
                    v-model="dateValue"
                    readonly
                    v-bind="$attrs"
                    @click="$attrs.readonly ? menu = false : menu = true"
      >
          <template v-slot:append>
              <v-icon @click="$attrs.readonly ? menu = false : menu = true" class="mt-1" color="#008EF0" small>
                  fas fa-calendar
              </v-icon>
          </template>
      </v-text-field>
    </template>
    <v-date-picker v-model="lazyValue" no-title scrollable @change="onDateChange">
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="menu = false">
          Cancel
      </v-btn>
      <v-btn text color="primary" @click="onSaveClick">
        OK
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment'

export default {
  name: 'MenuDatepicker',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: null
  },
  data() {
    return {
      menu: false,
      lazyValue: this.value
    }
  },
    watch: {
      value(newValue){
          this.lazyValue = newValue;
      }
    },
  methods: {
    onSaveClick() {
      let dataFormatada = this.formatDate(this.dateValue)
      this.$emit('change', dataFormatada)
      this.$refs.menu.save(this.lazyValue)
    },
    onDateChange() {
      let dataFormatada = this.formatDate(this.dateValue)
      this.$emit('change', dataFormatada)
      this.$refs.menu.save(this.lazyValue)
    },
    formatDate(v){
      const data = [v.substr(6,4), v.substr(3,2), v.substr(0,2)];
      return data.join('-');
    }
  },
  computed: {
    dateValue: {
      get() {
        const parsedDate = moment(this.lazyValue)
        if (!parsedDate.isValid() || !this.lazyValue) return ''
        return moment(this.lazyValue).format('DD/MM/YYYY')
      },
      set(value) {
        this.lazyValue = value
        this.$emit('change', this.formatDate(this.dateValue))
        this.$refs.menu.save(this.lazyValue)
      }
    }
  }
}
</script>

<style scoped>
.clickable:hover {
  cursor: pointer;
  user-select: none;
}
</style>
